<template>
    <div>
        <v-overlay :value="helpSystemVisible" :style="`width:${bgWidth}px;`" :dark="false" :color="'#333'" :opacity="0.95">
            <HintsDialogPage
                :spot="spot"
                @cancel="helpSystemVisible=false"
                @requestHint="onRequestHint"
                class="hints-dialog-container"
            />
        </v-overlay>

        <v-btn
            large
            depressed
            class="white--text help-btn"
            style="width:20%"
            :disabled="disabled"
            :color="color"
            :style="{'background-color': theme.btnColorPrimary }"
            @click="helpSystemVisible=true"
        >
            <v-icon class="help-icon" :color="theme.btnTextColor">mdi-help-circle</v-icon>
        </v-btn>
    </div>
</template>

<script>
import {layoutMixin} from "../../utils/layout-mixin";
import HintsDialogPage from "../../views/dashboard/HintsDialogPage.vue";

export default {
    mixins: [layoutMixin],
    components:{
        HintsDialogPage
    },
    props:{
        color:{
            type:String,
            default:'grey'
        },
        spot:{},
        disabled:{
            type:Boolean,
            default:false
        },
        buttonColor:{},
    },
    created() {
        this.assignPseudoElementStyle();
    },
    data() {
        return {
            helpSystemVisible:false,
            buttonColorValue: this.buttonColor,
            selectedIndex: 0,
        }
    },
    computed: {
        hintsList(){
            if(!this.spot || !this.spot.raetsel || !this.spot.raetsel.hints){
                return [];
            }
            const values = Object.values(this.spot.raetsel.hints);
            return values.sort((a,b)=>{
                const ao = typeof a.order==='number'?a.order:0;
                const bo = typeof b.order==='number'?b.order:0;
                return ao - bo;
            });
        },
        currentHint(){
            if(this.hintsList.length===0){
                return null;
            }
            const idx = Math.min(Math.max(this.selectedIndex,0), this.hintsList.length-1);
            return this.hintsList[idx];
        }
    },
    methods: {
        onRequestHint(hintId){
            this.$emit('requestHint', hintId);
        },
        reset(foundPasswordSpot){
            // Legacy API compatibility: previously used to control old password dialog
            // Keep as no-op to avoid runtime errors from callers.
            if(foundPasswordSpot){
                this.helpSystemVisible = false;
            }
        },
        increaseBrightness(colorValue,percent) {
            var ctx = document.createElement('canvas').getContext('2d');

            ctx.fillStyle = colorValue;
            ctx.fillRect(0,0,1,1);

            var color = ctx.getImageData(0,0,1,1);
            var r = color.data[0] - Math.floor( percent / 100 * 255 );
            var g = color.data[1] - Math.floor( percent / 100 * 255 );
            var b = color.data[2] - Math.floor( percent / 100 * 255 );
            return 'rgb('+r+','+g+','+b+')';
        },
        assignPseudoElementStyle() {
            this.buttonColorValue = this.increaseBrightness(this.theme.btnColorPrimary, 10);
            document.documentElement.style.setProperty('--btn-color', this.buttonColorValue);
        }
    },
}
</script>

<style lang="scss">
.help-btn {
    z-index: 2;
}
.spotGroupedButton.v-btn-toggle > .v-btn.v-btn.help-btn {
    background-color: var(--btn-color) !important;
    &.v-btn--active {
        background-color: var(--btn-color) !important;
    }
}
</style>